var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "translate(0.5)",
    fill: "#FFF0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.25 27.5H26.75C26.4185 27.5 26.1005 27.6317 25.8661 27.8661C25.6317 28.1005 25.5 28.4185 25.5 28.75V51.25C25.5 51.5815 25.6317 51.8995 25.8661 52.1339C26.1005 52.3683 26.4185 52.5 26.75 52.5H54.25C54.5815 52.5 54.8995 52.3683 55.1339 52.1339C55.3683 51.8995 55.5 51.5815 55.5 51.25V28.75C55.5 28.4185 55.3683 28.1005 55.1339 27.8661C54.8995 27.6317 54.5815 27.5 54.25 27.5ZM34.8907 42.5C34.149 42.5 33.424 42.2801 32.8073 41.868C32.1906 41.456 31.71 40.8703 31.4261 40.1851C31.1423 39.4998 31.0681 38.7458 31.2128 38.0184C31.3574 37.291 31.7146 36.6228 32.239 36.0983C32.7635 35.5739 33.4317 35.2167 34.1591 35.0721C34.8865 34.9274 35.6405 35.0016 36.3258 35.2855C37.011 35.5693 37.5967 36.0499 38.0087 36.6666C38.4208 37.2833 38.6407 38.0083 38.6407 38.75C38.6407 39.2425 38.5437 39.7301 38.3552 40.1851C38.1668 40.64 37.8906 41.0534 37.5423 41.4017C37.1941 41.7499 36.7807 42.0261 36.3258 42.2146C35.8708 42.403 35.3832 42.5 34.8907 42.5Z",
    fill: "#E34444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 37.5H50.5",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.25 42.5H50.5",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8906 42.5C36.9617 42.5 38.6406 40.8211 38.6406 38.75C38.6406 36.6789 36.9617 35 34.8906 35C32.8196 35 31.1406 36.6789 31.1406 38.75C31.1406 40.8211 32.8196 42.5 34.8906 42.5Z",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0488 46.2499C30.3263 45.1766 30.9524 44.2259 31.8289 43.5471C32.7054 42.8684 33.7825 42.5 34.8911 42.5C35.9997 42.5 37.0769 42.8682 37.9534 43.5469C38.8299 44.2256 39.4562 45.1763 39.7337 46.2496",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 27.5H26.75C26.0596 27.5 25.5 28.0596 25.5 28.75V51.25C25.5 51.9404 26.0596 52.5 26.75 52.5H54.25C54.9404 52.5 55.5 51.9404 55.5 51.25V28.75C55.5 28.0596 54.9404 27.5 54.25 27.5Z",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.624a3b7811778294ad110903f45e1a18.svg";
export { ForwardRef as ReactComponent };